import { OneBoxPage } from "@drift/oneplatfront";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLayout, useTranslation } from "@onefront/react-sdk";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import { Box, Button, Grid, Stack, useTheme } from "@vapor/react-material";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BusinessSteps } from "../../../../@types/enums/business/BusinessSteps";
import WorkspaceDetailsSectionTitle from "../../../../components/general/section-title";
import { useGetWorkspaceDetails } from "../../../../hooks/api/details/useGetWorkspaceDetails";
import DetailsSidebar from "../../../details/components/details/sidebar";
import { SidebarSkeleton } from "../../../details/components/skeletons/sidebar";
import { DetailsBusiness } from "../details_business";
import { BusinessStepper } from "../stepper";
import { BusinessAccounting } from "./sections/accounting";
import { BusinessDetails } from "./sections/details";
import { BusinessIvaProRata } from "./sections/ivaprorata";
import { BusinessSectionals } from "./sections/sectionals";
import { BusinessVatConfiguration } from "./sections/vatconfiguration";

export const NewBusiness = ({ section }) => {
    const {
        palette: {
            primary: { background: WhiteSmoke }
        }
    } = useTheme();

    const { t } = useTranslation();
    const { isEmbed } = useLayout();
    const navigate = useNavigate();
    const { workspaceId } = useParams();
    const { data, loading } = useGetWorkspaceDetails(workspaceId);
    const [business, setBusiness] = useState<any>(null);

    return (
        <OneBoxPage
            showCustomerSelector={false}
            headerLeft={
                <Button onClick={() => navigate(`../details/${workspaceId}/business`)}>
                    <ExtendedTypography color="primary.interactiveDefault">
                        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: 8 }} /> {t("business.back")}
                    </ExtendedTypography>
                </Button>
            }
            headerRight={<Box width={200}>&nbsp;</Box>}
            title={t("business.wizard.title")?.toUpperCase()}
            subtitle={t("business.wizard.subtitle")}
            sx={{
                ...(isEmbed && {
                    minHeight: "calc(100vh - 32px)"
                })
            }}
        >
            <Grid container>
                <Grid
                    item
                    md={4}
                    xl={2.75}
                    sx={{
                        background: WhiteSmoke,
                        ...(isEmbed
                            ? {
                                  minHeight: "calc(100vh - 112px)"
                              }
                            : { minHeight: "calc(100vh - 160px)" })
                    }}
                >
                    {loading && !data?.classifier ? (
                        <SidebarSkeleton withoutMenu />
                    ) : (
                        <DetailsSidebar data={data} withoutMenu />
                    )}
                    {loading && !business ? (
                        <SidebarSkeleton withoutMenu />
                    ) : (
                        business && <DetailsBusiness data={business} withoutMenu />
                    )}
                </Grid>
                <Grid item xs={12} md={8} xl={9.25} px={4} py={4}>
                    <Stack spacing={6}>
                        <Box>
                            <BusinessStepper stepActive={section} />
                        </Box>
                        <Stack spacing={4}>
                            <WorkspaceDetailsSectionTitle
                                title={t(`business.${section}.title`)}
                                subtitle={t(`business.${section}.subtitle`)}
                            />
                            <Box>
                                {section === BusinessSteps.details && (
                                    <BusinessDetails workspaceData={data} setBusiness={setBusiness} />
                                )}
                                {section === BusinessSteps.accounting && (
                                    <BusinessAccounting setBusiness={setBusiness} />
                                )}
                                {section === BusinessSteps.sectionals && (
                                    <BusinessSectionals setBusiness={setBusiness} />
                                )}
                                {section === BusinessSteps.vatconfiguration && (
                                    <BusinessVatConfiguration setBusiness={setBusiness} />
                                )}
                                {section === BusinessSteps.ivaprorata && (
                                    <BusinessIvaProRata setBusiness={setBusiness} />
                                )}
                            </Box>
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>
        </OneBoxPage>
    );
};
